import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'
import { errorsIsAnException, errorsIsOnlySummary, errorsWithoutSummary } from './helpers'
import GovActionErrors from './errors'
import GovActionErrorForm from './form'

const displayErrors = ({
  errors = {},
  onChange,
  onlyDisplayErrors = false,
  API_IS_READY = true,
}) => {
  if (errorsIsOnlySummary(errors) || errorsIsAnException(errors)) {
    return <FormDisplayErrors errors={errors.summary} />
  }

  // If we are only displaying errors, we don't need to build a form
  return onlyDisplayErrors ? null : API_IS_READY ? ( // as ideally we'd like to display a form vs just errors // Once the API is ready this flag and prop can be removed
    <GovActionErrorForm errors={errorsWithoutSummary(errors)} onChange={onChange} />
  ) : (
    <GovActionErrors errors={errorsWithoutSummary(errors)} />
  )
}

const GovListErrors = ({ errors = {}, onChange, onlyDisplayErrors, API_IS_READY = false }) => {
  return Object.keys(errors).length === 0
    ? null
    : displayErrors({ errors, onChange, onlyDisplayErrors, API_IS_READY })
}

export default GovListErrors



// WEBPACK FOOTER //
// ./src/ui/forms/form-from-errors/index.js